"use strict";
/**
 * 定义组件的props类型，此文件会根据应用，被storybook-doc自动生成属性文档
 * 需为每个属性写好注释，定义default 默认值
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=type.js.map